import { NavLink } from "react-router-dom";
import { cn } from "@/lib/utils.js";

const linkClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    "block rounded-md px-3 py-2 text-sm font-medium transition-colors",
    isActive ? "bg-accent text-accent-foreground" : "text-muted-foreground hover:bg-accent/50 hover:text-foreground"
  );

export function SidebarNav({ onNavigate }: { onNavigate?: () => void }) {
  return (
    <nav className="space-y-1 p-4" aria-label="Main">
      <NavLink to="/dashboard" className={linkClass} onClick={() => onNavigate?.()}>
        Decisions
      </NavLink>
    </nav>
  );
}
